export default {
  autoInit: false,
  dataScroll: 'scroll-stash',
  dataAnchor: 'scroll-stash-anchor',
  selectorAnchor: '',
  selectorAnchorParent: '',
  selectorTopElem: '',
  selectorBotElem: '',
  alignment: 'nearest', // start | end | nearest
  behavior: 'auto', // auto | smooth
  anchorPadding: 16,
  saveKey: 'ScrollStash',
  throttleDelay: 100,
  customEventPrefix: 'scroll-stash:',
};
